import { CONDITION_SAFE_PLAY_ID } from 'apiConstants';
import { type AuthenticatedUserInterface, type SafePlayStatus } from 'typedefs/authTypes';

export const getUserSafePlayStatus = (user?: AuthenticatedUserInterface): SafePlayStatus | undefined => {
  const safePlayCondition = (user?.Conditions || []).find(
    (condition) => condition.ConditionID === CONDITION_SAFE_PLAY_ID,
  );

  return safePlayCondition?.Data as SafePlayStatus;
};
